import { ReactNode } from "react";
import Icon from "../Icon/Icon";

interface CardProps {
    children: React.ReactNode;
    title?: string
    subtitle?: string
    className?: string
    bodyClassName?: string
    icon?: string
    buttonComponent?: ReactNode 
    headerClassName?: string
    hiddenHeader?: boolean
}
export const Card: React.FC<CardProps> = (props) => {
    const { hiddenHeader, className, subtitle, title, icon, children, buttonComponent, headerClassName, bodyClassName } = props
    return (
        <section className={`h-fit border-gray-700 !bg-gray-800 border rounded-lg w-full flex p-4 flex-col gap-4 ${className}`}>
            {!hiddenHeader && <div className={`flex flex-col ${headerClassName}`}>
                <div className="flex gap-3">
                    {icon ? <Icon name={icon} className="text-white-500 mt-2 min-w-[24px]" size={24} /> : null}
                    <div className="flex flex-col">
                        <h2 className="font-bold text-lg">{title}</h2>
                        {subtitle && <small className="text-gray-400 text-base">{subtitle}</small>}
                    </div>
                    <div className="ml-auto">
                        {buttonComponent}
                    </div>
                </div>
            </div>}
            <div className={bodyClassName}>{children}</div>
        </section>
    )
}